import React, { useContext, useState, useEffect } from "react";
import "./protection.css";
import { protectionData } from "../../json/protection";
import { LanguageContext } from "../../context/LanguageContext/LanguageContext";
import { Parallax } from "react-scroll-parallax";

// Hook para detectar si es móvil
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const Protection = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "ES" ? protectionData.ES : protectionData.EN;

  const isMobile = useIsMobile();

  // Parallax Props más atractivos en mobile
  const parallaxProps = isMobile
    ? {
      // opacity: [0, 2],
      scale: [0.9, 1],
      // speed: -3,
      shouldAlwaysCompleteAnimation: true,
    }
    : {
      // opacity: [0, 2],
      // speed: -10,
      shouldAlwaysCompleteAnimation: true,
    };

  return (
    <div
      className="protection-container"
      style={{
        backgroundImage: `url(${data.image})`,
      }}
    >
      <Parallax {...parallaxProps}>
        <div className="protection-text">
          <h1>{data.title}</h1>
          {data.description.map((line, idx) => (
            <p key={idx}>{line}</p>
          ))}
          <div className="protection-gallery">
            {data.images.map((src, index) => (
              <div
                key={index}
                className="img-protection"
                style={{
                  backgroundImage: `url(${src})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "100%",
                  height: "80px",
                }}
              />
            ))}
          </div>
        </div>
      </Parallax>
    </div>
  );
};

export default Protection;
